import CardViagensDetails from "../../styles/components/CardViagensDetails";

import { BiSolidPlaneTakeOff, BiSolidPlaneLand } from "react-icons/bi";
import { useNavigate } from "react-router";
import Image from "./Image.component";
import { Pacote } from "../../types";

interface CardProps {
  data: Pacote;
}

const CardViagens = ({ data }: CardProps) => {
  const navigate = useNavigate();

  return (
    <CardViagensDetails
      onClick={() =>
        navigate(
          `/viagens/${data.title.replace(/ /g, "-").toLocaleLowerCase()}?id=${
            data.id
          }`
        )
      }
    >
      <div className="image">
        <Image src={data.imagesUrl[0]} width="100%" height="250px" />
        <div className="tag" style={getStyle(data.tag)}>
          {data.tag}
        </div>
      </div>
      <div className="content-card">
        <div className="title">{data.title}</div>
        <div className="horario">
          <div className="saida">
            <div className="icon">
              <BiSolidPlaneTakeOff />
            </div>
            <p>{getDate(data.data_partida)}</p>
          </div>
          <div className="retorno">
            <div className="icon">
              <BiSolidPlaneLand />
            </div>
            <p>{getDate(data.data_retorno)}</p>
          </div>
        </div>
        <div className="preco">
          <p className="tip-preco">Pacote a partir de</p>
          <div className="preco-div">
            <span>R$</span> <p>{data.preco.slice(0, -3)}</p>
          </div>
        </div>
      </div>
    </CardViagensDetails>
  );
};

const getStyle = (tag: string) => {
  if (tag === "Pacote") {
    return {
      background: "#DF8925",
      color: "white",
    };
  }

  if (tag === "Caravana") {
    return {
      background: "#038EAD",
      color: "white",
    };
  }

  if (tag === "Excursão") {
    return {
      background: "#BF0268",
      color: "white",
    };
  }
};

const getDate = (inicial: string) => {
  const monthNames = [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez",
  ];

  const date = new Date(inicial);

  return `${date.getDate()} de ${
    monthNames[date.getMonth()]
  } ${date.getFullYear()}`;
};

export default CardViagens;
